if ( typeof QuickAddToCart !== 'function' ) {

	const itgFreeGiftLabel = document.body ? document.body.getAttribute('data-free-gift-label') : '';

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{

				if ( ! document.body.classList.contains('template-cart') ) {
					document.getElementById('site-cart-sidebar').show();
					if ( KROWN.settings.cart_action == 'overlay') {
						document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
						});
						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
						});
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
					};
				}

				console.log("quickAdd to cart");
				updateCartProgress();

			});

			function updateCartProgress() {


				let storedCartPrice = parseFloat(localStorage.getItem('loadedCartPrice')) || 0;

						console.log('Stored cart price from localStorage:', storedCartPrice);

						console.log("Cart successfully updated");

						const subTotalElem = document.getElementById('AjaxCartSubtotal');
						if (!subTotalElem) return;

						let subTotalAmt = subTotalElem.querySelector('.cart__total')?.getAttribute("data-total-price");
						if (!subTotalAmt) return;
					
						let cartPrice = parseFloat(subTotalAmt.replace(/,/g, '').trim());
						console.log(isNaN(cartPrice), "cartPrice", cartPrice);

						const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
						if (!mainProgressWrapper) return;

						const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
						if (!cartBar) return;

						console.log(subTotalAmt);

						const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
						if (isNaN(maxAmountPrice) || maxAmountPrice <= 0) return;

						const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");

						(async () => {
							// Fetch current cart
							const cartResponse = await fetch('/cart.js');
							const cart = await cartResponse.json();

							console.log(cart , "cart_data_quick_buy") ;

							let allProductsHTML = '';

							const mainProgressWrapper = document.querySelector('.cart_drawer_progress_bar_inner_wrapper');
							if (!mainProgressWrapper) return;

							const cartBar = mainProgressWrapper.querySelector(".cart_drawer_progress_bar");
							if (!cartBar) return;

							const maxAmountPrice = parseFloat(cartBar.getAttribute("data-maxamt"));
							const subTotalElem = document.getElementById('AjaxCartSubtotal')?.querySelector('.cart__total');
							const cartPrice = parseFloat(subTotalElem?.getAttribute("data-total-price")?.replace(/,/g, '').trim() || 0);

							const allSteps = mainProgressWrapper.querySelectorAll(".progbar_counter");
							if (!allSteps.length) return;

							// New Final allSteps Code For Free Product 

							// allSteps.forEach((step, index) => {
							// 	const stepAmount = parseFloat(step.getAttribute("data-amount"));
							// 	if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

							// 	step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

							// 	const productElem = step.querySelector(".product_or_discount");
							// 	if (!productElem) return;

							// 	const type = productElem.getAttribute("data-product-or-discount");
							// 	const productVariantId = productElem.getAttribute("data-product-id");
							// 	const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

							// 	// -----------------------------
							// 	// IF (cartPrice >= stepAmount)
							// 	// -----------------------------
							// 	if (cartPrice >= stepAmount && type === "product") {

							// 		const hasFreeItem = cart.items.some(item => {
							// 			const id = item.id.toString().replace("item-", "");
							// 			return id === productVariantId.toString() && Number(item.price) === 0;
							// 		});

							// 		const hasPaidItem = cart.items.some(item => {
							// 			const id = item.id.toString().replace("item-", "");
							// 			return id === productVariantId.toString() && Number(item.price) > 0;
							// 		});

							// 		console.log(hasFreeItem, "hasFreeItem (price=0)");
							// 		console.log(hasPaidItem, "hasPaidItem (price>0)");

							// 		// Rule: DO NOT render if a free version already exists
							// 		const shouldRender = !hasFreeItem;

							// 		if (shouldRender) {
							// 			allProductsHTML += `
							// 				<div class="single_step_product_wrapper" id="${wrapperId}">
							// 					<div class="free_product_wrapper_inner">
							// 						${productElem.innerHTML}
							// 					</div>
							// 				</div>`;
							// 		}
							// 	}

							// 	// -----------------------------
							// 	// ELSE (cartPrice < stepAmount)
							// 	// -----------------------------
							// 	else {

							// 		// 1. Remove accordion
							// 		const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
							// 		if (mainAccordion) {
							// 			const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
							// 			if (productWrapper) productWrapper.remove();
							// 		}

							// 		// 2. Remove ONLY free version from cart
							// 		if (type === "product") {

							// 			// Find all matched items
							// 			const matchedItems = cart.items.filter(item => {
							// 				const id = item.id.toString().replace("item-", "");
							// 				return id === productVariantId.toString();
							// 			});

							// 			matchedItems.forEach(item => {
							// 				const price = Number(item.price);
							// 				if (price === 0) {
							// 					console.log("Removing free item:", item.id);
							// 					removeProductFromCart(productVariantId);
							// 				} else {
							// 					console.log("Keeping paid item:", item.id);
							// 				}
							// 			});
							// 		}
							// 	}
							// });

							allSteps.forEach((step, index) => {
								const stepAmount = parseFloat(step.getAttribute("data-amount"));
								if (isNaN(stepAmount) || maxAmountPrice <= 0) return;

								step.style.left = Math.round((stepAmount / maxAmountPrice) * 100) + "%";

								const productElem = step.querySelector(".product_or_discount");
								if (!productElem) return;

								const type = productElem.getAttribute("data-product-or-discount");
								const productVariantId = productElem.getAttribute("data-product-id");
								const wrapperId = `cart_drawer_free_product_wrapper_step_${index}`;

                                const productIdOnly = productElem.querySelector('.cart_free_product_wrapper')?.getAttribute("data-product-id");

                                // -----------------------------
                                // IF (cartPrice >= stepAmount)
                                // -----------------------------

                                if (cartPrice >= stepAmount && type === "product") {

                                    // Check ANY variant of the same product
                                    const hasFreeItem = cart.items.some(item => {
                                        console.log(item.product_id , "item.product_id" );
                                        console.log(productVariantId , "Product-variant_id" );
                                        console.log(productIdOnly , "Product_id" );
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) === 0;
                                    });

                                    const hasPaidItem = cart.items.some(item => {
                                        console.log(item.product_id , "item.product_id" );
                                        console.log(productVariantId , "Product-variant_id" );
                                        console.log(productIdOnly , "Product_id" );
                                        return item.product_id.toString() === productIdOnly.toString() && Number(item.price) > 0;
                                    });

                                    console.log(hasFreeItem, "hasFreeItem (price=0)");
                                    console.log(hasPaidItem, "hasPaidItem (price>0)");

                                    // If ANY variant exists → do NOT render
                                    // const shouldRender = !hasFreeItem && !hasPaidItem;
                                    const shouldRender = !hasFreeItem;

                                    if (shouldRender) {
                                        allProductsHTML += `
                                            <div class="single_step_product_wrapper" id="${wrapperId}">
                                                <div class="free_product_wrapper_inner">
                                                    ${productElem.innerHTML}
                                                </div>
                                            </div>`;
                                    }
                                }


                                else {

                                        // 1. Remove accordion HTML
                                        const mainAccordion = document.querySelector('.main_free_product_accordion_wrapper');
                                        if (mainAccordion) {
                                            const productWrapper = mainAccordion.querySelector(`#${wrapperId}`);
                                            if (productWrapper) productWrapper.remove();
                                        }

                                        // 2. Remove only free variant from cart
                                        if (type === "product") {

                                            const matchedItems = cart.items.filter(item => {
                                                return item.product_id.toString() === productIdOnly.toString();
                                            });
                                            

                                            matchedItems.forEach(item => {
                                                if (Number(item.price) === 0) {
                                                    console.log("Removing free item:", item.variant_id);
                                                    // by line key when available: the variant-id remove link can hit a paid line of the same variant
                                                    if (typeof window.itgRemoveFreeGiftLine === 'function' && item.key) {
                                                        window.itgRemoveFreeGiftLine(item);
                                                    } else {
                                                        removeProductFromCart(item.variant_id);
                                                    }
                                                } else {
                                                    console.log("Keeping paid variant:", item.variant_id);
                                                }
                                            });
                                        }
                                    }

                                });

							let sidebarWrapper = document.querySelector('.sidebar__free_product_wrapper');

							let cartPageWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');

							if (!cartPageWrapper && document.body.classList.contains('template-cart')) {
								const cartItemsWrapper = document.querySelector('.cart-form__items');
								if (cartItemsWrapper) {
									cartPageWrapper = document.createElement('div');
									cartPageWrapper.classList.add('sidebar__free_product_wrapper');
									cartItemsWrapper.appendChild(cartPageWrapper);

										if (allProductsHTML.trim() !== '') {
											const wrapper = document.createElement('div');
											wrapper.classList.add('main_free_product_accordion_wrapper');
											wrapper.innerHTML = `
												<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
													<span class="productTitleItg">${itgFreeGiftLabel}</span>
													<span class="svg-wrapper accordion_down_icon">
														<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
															<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
														</svg>
													</span>
												</div>
												<div class="free_product_wrapper" style="display:block;">
													<div class="free_product_inner_container">
														${allProductsHTML}
													</div>
												</div>
											`;

											// Toggle accordion
											wrapper.querySelector('.headerItg').addEventListener('click', () => {
												const content = wrapper.querySelector('.free_product_wrapper');
												content.style.display = content.style.display === 'block' ? 'none' : 'block';
											});

											cartPageWrapper.appendChild(wrapper);
										} else {
											cartPageWrapper.classList.add('hideWrapper');
										}
									
									}
								}else{
									let sidebarWrapper = document.querySelector('.cart-form__items .sidebar__free_product_wrapper');
									if (sidebarWrapper) {
										sidebarWrapper.innerHTML = '';
									}
								}       


							// CART DRAWER: clear previous content
							if (sidebarWrapper) {
								sidebarWrapper.innerHTML = '';
							}

						
							// Only build accordion if there are products
							if (allProductsHTML.trim() !== '') {
								const wrapper = document.createElement('div');
								wrapper.classList.add('main_free_product_accordion_wrapper');
								wrapper.innerHTML = `
									<div class="headerItg active" style="cursor:pointer; display:flex; justify-content:space-between; align-items:center;">
										<span class="productTitleItg">${itgFreeGiftLabel}</span>
										<span class="svg-wrapper accordion_down_icon">
											<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
												<path d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"/>
											</svg>
										</span>
									</div>
									<div class="free_product_wrapper" style="display:block;">
										<div class="free_product_inner_container">
											${allProductsHTML}
										</div>
									</div>
								`;

								// Toggle accordion
								wrapper.querySelector('.headerItg').addEventListener('click', () => {
									const content = wrapper.querySelector('.free_product_wrapper');
									content.style.display = content.style.display === 'block' ? 'none' : 'block';
								});

								sidebarWrapper.classList.remove('hideWrapper');
								sidebarWrapper.appendChild(wrapper);
							} else {
								sidebarWrapper.classList.add('hideWrapper');
							}
						})();



						// Filled bar
						if (!isNaN(cartPrice)) {
							let filledPercent = ((cartPrice * 100) / maxAmountPrice);
							filledPercent = Math.min(Math.max(filledPercent, 0), 100);

							const filledBar = cartBar.querySelector(".cart_drawer_filled_bar");
							if (filledBar) {
								filledBar.style.width = filledPercent + "%";

							}
						
						}

						// subtotalAmt Updated

						console.log(subTotalAmt);

						document.querySelector('.cart_drawer_progress_bar').setAttribute("data-cart-price" , subTotalAmt ) ;
						localStorage.setItem('loadedCartPrice', subTotalAmt);


					// removeProductFromCart  function //

					async function removeProductFromCart(productVariantId) {
						try {
							const lineItemElem = document.querySelector(`#item-${productVariantId}`);

							if (lineItemElem) {
								const removeBtn = lineItemElem.querySelector('a.remove, button.remove');

								if (removeBtn) {
									removeBtn.click(); // trigger click on the remove button
									console.log(`Clicked remove for variant ${productVariantId}`);


								} else {
									console.warn(`Remove button not found for variant ${productVariantId}`);
								}
							} else {
								console.warn(`Line item not found in DOM for variant ${productVariantId}`);
							}
						} catch (err) {
							console.error(`Error removing variant ${productVariantId}:`, err);
						}
					}	


			}

			
		}
		
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {

		constructor(){
			super();
			if ( this.querySelector('a') ) {
				this.init();
			}
		}

		initModalProduct(){

			this.quickViewModal.querySelectorAll('[data-js-close]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					this.quickViewModal.hide();
				});
			});

			if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
				this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
					document.getElementById('site-cart-sidebar')?.scrollTo({top: 0, behavior: 'smooth'});
					this.quickViewModal.hide();
				});
			}

			if ( Shopify && Shopify.PaymentButton ) {
				setTimeout(()=>{
					Shopify.PaymentButton.init();
				}, 50);
			}

			const productVariants = this.quickViewModal.querySelector('product-variants');
			if ( ! productVariants._defaultToFirstVariant ) {
				if ( parseInt(productVariants.dataset.variants) == 1 ) {
					productVariants.updateBuyButtons();
					this.quickViewModal.querySelector('product-page').onVariantChangeHandler({target:productVariants});
				}
			}

		}

		init(){

			this.quickViewModal = null;
			this.querySelector('a').addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					window.lastFocusedElm = this.querySelector('a');
				}
			})
			this.querySelector('a').addEventListener('click', e=>{

				e.preventDefault();

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;

					target.classList.add('working');

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

							// create modal w content

							const quickViewContainer = document.createElement('div');
							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"	
								class="modal modal--product" 
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true" 
							>
								<div class="container--medium">
									<div class="modal-content" data-js-product-page>
										<button class="modal-close" data-js-close style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);
							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

							setTimeout(()=>{
								this.initModalProduct();
							}, 100);
							this.quickViewModal.querySelector('[data-js-product-page]').addEventListener('reload', ()=>{
								this.initModalProduct();
							});

							if ( ! window.productPageScripts ) {
								const scripts = this.quickViewModal.querySelectorAll('script');
								scripts.forEach(elm=>{
									const script = document.createElement('script');
									script.src = elm.src;
									document.body.append(script);
									window.productPageScripts = true;
								});
							}

							setTimeout(()=>{
								this.quickViewModal.show();
								target.classList.remove('working');
							}, 250);
							
						});

				} else {
					this.quickViewModal.show();
				}

			})
		}
	}

  if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}